import { gql } from '@apollo/client';

export const ADD_RESOURCE = gql`
  mutation AddResource($input: ResourceApiRequestInput!) {
    addResource(input: $input) {
      success
      message
      messageCode
      data {
        id
      }
    }
  }
`;

export interface AddResourceInput {
  code: string;
  name: string;
  type: string; // "MENU" | "BUTTON"
  parentId: number;
  description?: string | null;
}

export interface AddResourceResponse {
  addResource: {
    success: boolean;
    message: string;
    messageCode?: string | null;
    data?: { id?: number | string | null } | null;
  };
}

export interface AddResourceVariables {
  input: AddResourceInput;
}

